
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"45","height":"31","rx":"5.5","fill":"#fff","stroke":"#EEE"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.104 12l-3.76 8.639h4.501l.558-1.378h1.275l.558 1.378h4.954v-1.052l.441 1.052h2.563l.441-1.074v1.073h10.303l1.253-1.341 1.172 1.341 5.292.012-3.771-4.307L39.655 12h-5.21l-1.219 1.317L32.09 12H20.882l-.962 2.23-.985-2.23h-4.491v1.015l-.5-1.015h-3.84zm.871 1.227h2.194l2.493 5.857v-5.857h2.403l1.926 4.2 1.776-4.2h2.39v6.198h-1.454l-.012-4.857-2.121 4.857h-1.302l-2.133-4.857v4.857h-2.993l-.568-1.39H10.51l-.567 1.39H8.34l2.636-6.198zm20.43 0h-5.916v6.195h5.824l1.878-2.053L35 19.422h1.89l-2.749-3.08 2.75-3.115h-1.81l-1.868 2.03-1.81-2.03zm-19.363 1.048l-1.01 2.476h2.019l-1.009-2.476zm14.908 1.367V14.509h3.691l1.61 1.81-1.681 1.82h-3.62v-1.236h3.227v-1.261H26.95z","fill":"#1F72CD"}})])
          )
        }
      }
    